import { Button, Grid } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FileInputButton from "@/components/fileInputButton";
import IconButton from "@mui/material/IconButton";
import { getBase64 } from "@/utils/utils";
import { toast } from "react-toastify";
import { useState } from "react";
import serviceLancamentoManual from "@/services/serviceLancamentoManual";
import { LoadingButton } from "@mui/lab";

export default function UploadLancamentoManual({ onClose, onSuccess }) {
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileBase64, setSelectedFileBase64] = useState("");
    const [isDisable, setDisable] = useState(false);
    const [isLoading, setLoading] = useState(false);

    const clearFile = () => {
        setSelectedFile(null);
        setSelectedFileBase64("");
    };

    const handleFileInput = (e: any) => {
        const extension = e.target.files[0].name.split(".").pop().toLowerCase();

        if (["csv"].includes(extension)) {
            setSelectedFile(e.target.files[0]);

            const size = e.target.files[0].size / 1024 / 1024;

            if (size > 10) {
                toast.error("O tamanho do arquivo selecionado não pode ser maior do que 10MB");
                clearFile();
            }

            getBase64(e.target.files[0]).then((result) => {
                setSelectedFileBase64(result);
            });
        } else {
            toast.error("O arquivo selecionado é inválido. É necessário anexar apenas no formato CSV!");
            clearFile();
        }
    };

    const onSubmit = () => {
        setDisable(true);
        setLoading(true);

        if (!selectedFile || !selectedFileBase64) {
            toast.error("É necessário anexar o arquivo (CSV) da planilha de Lançamentos Manuais!");
            setDisable(false);
            setLoading(false);
        } else {
            const formData = new FormData();
            formData.append("dataFile", selectedFileBase64.replace("data:text/csv;base64,", ""));

            serviceLancamentoManual
                .upload(formData)
                .then((result) => {
                    if (result) {
                        toast.info("O Arquivo será carregado, por favor aguarde.");
                        onClose(true);
                        onSuccess();
                    }
                })
                .finally(() => {
                    setDisable(false);
                    setLoading(false);
                    clearFile();
                });
        }
    };

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open
        >
            <DialogTitle>
                Importar Planilha de Lançamentos
                <IconButton
                    aria-label="close"
                    onClick={() => {
                        onClose();
                    }}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={1}>
                    <Grid item xs={12} md={12}>
                        <FileInputButton accept="text/csv" onChange={handleFileInput} selectedFile={selectedFile} />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                <Button
                    onClick={onClose}
                    color="warning"
                    variant="contained"
                    style={{ width: "159px", height: "44px" }}
                >
                    Cancelar
                </Button>
                <LoadingButton
                    onClick={onSubmit}
                    loading={isLoading}
                    disabled={isDisable}
                    color="primary"
                    variant="contained"
                    style={{ width: "159px", height: "44px" }}
                >
                    Carregar
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}
